import uniqBy from 'lodash/uniqBy';
import emlformat from '../lib/eml-format';

export class EmlMessage {
  constructor(
    public subject = '',
    public to = {},
    public html = '',
    public attachments = [],
    public headers = {}
  ) {}

  addAttachment(attachment) {
    this.attachments = this.attachments.concat(attachment);
    this.attachments = uniqBy(this.attachments, 'name');
  }

  createMessage() {
    let message = '';
    emlformat.build(this, (err: string, result: string) => {
      if (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
      message = result;
    });
    let textFile = null;

    function makeTextFile(text: string) {
      const data = new Blob([text], { type: 'text/html' });
      if (textFile !== null) {
        window.URL.revokeObjectURL(textFile);
      }
      textFile = window.URL.createObjectURL(data);
      return textFile;
    }

    return makeTextFile(message);
  }
}
